import { render, staticRenderFns } from "./InsuranceBenefits.vue?vue&type=template&id=44334696&scoped=true"
import script from "./InsuranceBenefits.vue?vue&type=script&lang=js"
export * from "./InsuranceBenefits.vue?vue&type=script&lang=js"
import style0 from "./InsuranceBenefits.vue?vue&type=style&index=0&id=44334696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44334696",
  null
  
)

export default component.exports